import { BaseWidgetEditorComponent } from '@juvare/widget-ui/BaseWidgetEditorComponent';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { FormControl } from '@mui/material';
import React from 'react';
import { defaultContentSizeLimit, defaultImageSizeLimit, RichTextEditor } from '../RichTextEditor';
import { buildEventTab, buildGeneralTab, buildHiddenTab, showWidgetEditDialog } from '../WidgetEditDialog';
import { FormHelperErrorDescription } from '../WidgetForm/Components';
import { defaultWidgetLabelProvider, getVisibleError, handleWidgetUpdate, isSkipValidate, makeNewConfigUnique, renderForm, validateCustom, } from '../WidgetForm/Utils';
import { type } from './types';
const WidgetFormRichTextElement = (props) => {
    var _a, _b, _c, _d;
    const data = props.getData();
    const error = getVisibleError(props);
    return (React.createElement(FormControl, { fullWidth: true, error: !!error },
        React.createElement(RichTextEditor, { data: (_a = data === null || data === void 0 ? void 0 : data.html) !== null && _a !== void 0 ? _a : '', editorInit: (_b = props.config) === null || _b === void 0 ? void 0 : _b.editorInit, disabled: (_c = props.config) === null || _c === void 0 ? void 0 : _c.disabled, onEditorChange: (htmlMessage) => {
                props.setData(Object.assign(Object.assign({}, data), { html: htmlMessage }));
                renderForm(props, { changed: true, autoSaveDebounce: props.config.autoSave });
            }, tinymceScriptSrc: (_d = props.rootParams.globalWidgetConfig) === null || _d === void 0 ? void 0 : _d.tinymceScriptSrc, contentSizeLimit: props.config.contentSizeLimit, imageSizeLimit: props.config.imageSizeLimit }),
        React.createElement(FormHelperErrorDescription, { error: error, description: props.config.description })));
};
const WidgetFormRichTextEditor = (props) => {
    return (React.createElement(BaseWidgetEditorComponent, Object.assign({}, props, { widgetLabelProvider: defaultWidgetLabelProvider, onEditWidget: (endEditing) => showWidgetEditDialog(props, endEditing, { title: 'Rich Text Editor: ' + props.config.label }, buildGeneralTab(props, {
            keyOptional: true,
            labelOptional: true,
            children: [
                {
                    type: 'form.checkbox',
                    key: 'disabled',
                    label: 'Disabled',
                },
                {
                    type: 'form.number',
                    key: 'contentSizeLimit',
                    label: 'Editor Content Size Limit (KB)',
                    validate: {
                        max: defaultContentSizeLimit,
                    },
                },
                {
                    type: 'form.number',
                    key: 'imageSizeLimit',
                    label: 'Image Upload Size Limit (KB)',
                    validate: {
                        max: defaultImageSizeLimit,
                    },
                },
            ],
        }), buildHiddenTab(props), buildEventTab(props, { eventOnChange: true, autoSave: true })) }),
        React.createElement(WidgetFormRichTextElement, Object.assign({}, props))));
};
export const widgetFormRichTextEditor = {
    type,
    validate: (props) => {
        var _a, _b;
        if (isSkipValidate(props)) {
            return;
        }
        const value = props.getData();
        if (((_a = props.config.validate) === null || _a === void 0 ? void 0 : _a.required) && !(value === null || value === void 0 ? void 0 : value.html)) {
            return (_b = props.config.validate.requiredMessage) !== null && _b !== void 0 ? _b : (props.config.label ? props.config.label + ' is required' : 'Required');
        }
        return validateCustom(props, value);
    },
    update: handleWidgetUpdate,
    component: WidgetFormRichTextElement,
    icon: React.createElement(FormatListBulletedIcon, { fontSize: 'small' }),
    editorComponent: WidgetFormRichTextEditor,
    createWidget: (rootConfig, editorPath, widgets) => makeNewConfigUnique(rootConfig, editorPath, widgets, { type, key: 'richTextEditor', label: 'Rich Text Editor' }),
};
